import { BlankLayout } from '@/components/layouts';
// 若一个模块的路由超过两个，则单独抽离作为一个路由模块文件引入
import SchemeRouter from './modules/scheme';
import CourseRouter from './modules/course';
import MaterialRouter from './modules/material';
import CommunityRouter from './modules/community';
import ActivityRouter from './modules/activity';
import TrainRouter from './modules/train';
import HelpRouter from './modules/help';
import ScoreMarketRouter from './modules/score-market';
import SystemTextListRouter from './modules/system-text';
import HomePageRouter from './modules/homepage';
import QuoteRouter from './modules/quote';
import TrainingCampRouter from './modules/training-camp'; // 新手集训营
import LiveRouter from './modules/live'; // 直播

const Exception404 = 'https://3vj-fe.3vjia.com/project/designer-h5/images/default/1.8.0/exception_404.png';

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { title: '首页', hideBanner: true },
  },
  LiveRouter,
  TrainingCampRouter,
  QuoteRouter,
  SchemeRouter,
  CourseRouter,
  MaterialRouter,
  CommunityRouter,
  ActivityRouter,
  TrainRouter,
  HelpRouter,
  ScoreMarketRouter,
  SystemTextListRouter, // 系统文本信息路由集合
  ...HomePageRouter, // 主页路由集合
  {
    path: '/service-market',
    name: 'Service.Market',
    component: BlankLayout,
    meta: { module: '服务市场' },
    children: [
      {
        path: '/service-market/:id',
        name: 'Service.Market.Details',
        component: () => import(/* webpackChunkName: 'service-details' */ '../views/service-market/ServiceDetails.vue'),
        meta: { title: '服务详情', hideBanner: true },
      },
    ],
  },
  {
    path: '/newcomer-activity',
    name: 'Newcomer.Activity',
    component: BlankLayout,
    meta: { module: '新人礼包' },
    children: [
      {
        path: '/newcomer-activity/app-gift',
        name: 'Newcomer.Activity.App',
        component: () => import(/* webpackChunkName: 'newcomer-activity-app' */ '../views/gift/GiftOld.vue'),
        meta: { title: '新用户礼包', titleAlias: 'App新人礼包', hideBanner: true },
      },
    ],
  },
  {
    path: '/workbench',
    name: 'Workbench',
    component: BlankLayout,
    meta: { module: '工作台' },
    children: [
      {
        path: '/workbench/data-analysis',
        name: 'Workbench.DataAnalysis',
        component: () => import(/* webpackChunkName: 'workbench-data-analysis' */ '../views/workbench/DataAnalysis.vue'),
        meta: { title: '数据分析', hideBanner: true },
      },
      {
        path: '/workbench/official-account',
        name: 'Workbench.OfficialAccount',
        component: () => import(/* webpackChunkName: 'workbench-official-account' */ '../views/workbench/OfficialAccount.vue'),
        meta: { title: '引导页', hideBanner: true, requiredLogin: true },
      },
    ],
  },
  {
    path: '/door-model',
    name: 'Door.Model',
    component: BlankLayout,
    meta: { module: '户型' },
    children: [
      {
        path: '/door-model/:id',
        name: 'Door.Model.Details',
        component: () => import(/* webpackChunkName: 'door-model-details' */ '../views/door-model/DoorModelDetails.vue'),
        meta: { title: '户型详情' },
      },
    ],
  },
  {
    path: '/magic-pen/:id',
    name: 'Magic.Pen.Details',
    component: () => import(/* webpackChunkName: 'magic-pen-details' */ '../views/magic-pen/index.vue'),
    meta: { title: '神笔动画', hideBanner: true },
  },
  {
    path: '/xinstall',
    name: 'Xinstall',
    component: () => import(/* webpackChunkName: 'xinstall' */ '../views/Xinstall.vue'),
    meta: { title: 'xinstall', hideBanner: true },
  },
  // {
  //   path: '/weixin',
  //   name: 'WeiXin',
  //   component: () => import(/* webpackChunkName: 'xinstall' */ '../views/TestWeixin.vue'),
  //   meta: { title: 'weixin-test', hideBanner: true },
  // },
  {
    path: '/check-message',
    name: 'CheckMessage',
    component: () => import(/* webpackChunkName: 'check-message' */ '../views/LinkedMe.vue'),
    meta: { title: '查看消息', alias: '查看App消息通知', hideBanner: true },
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "exception" */ '../views/Exception.vue'),
    meta: { title: '404', hideBanner: true },
    props: {
      sourceData: {
        imageUrl: Exception404,
        type: 404,
        title: '页面走丢了啦',
      },
    },
  },
];

// 调试页面路由
if (['dev', 'test'].includes(process.env.VUE_APP_ENV)) {
  routes.push({
    path: '/debugger',
    name: 'Debugger',
    component: () => import(/* webpackChunkName: "debugger" */ '../views/Debugger.vue'),
    meta: { title: '调试', hideBanner: true },
  });
}

routes.push({
  path: '/*',
  redirect: '/404',
});

export default routes;
